import React, { useState, useRef, useEffect } from "react";
import RecordVideo from "@revvsales/record-video";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@revvsales/components";

const RecordVideoComponent = props => {
  const [recording, setRecording] = useState("NotStarted");
  const [videoUrl, setVideoUrl] = useState("");
  const [viewVideo, setViewVideo] = useState(false);
  const [thumbnailFile, setThumbnailFile] = useState("");
  const [videoFile, setVideoFile] = useState("");
  const [downloadingVideo, setDownloadingVideo] = useState("NotStarted");
  const [error, setError] = useState(false);
  const [timerStarted, setTimerStarted] = useState(false);
  const recordVideo = useRef(null);
  const [tempFlag, setTempFlag] = useState(false);

  console.debug("--------------------------");
  console.debug("recording", recording);
  console.debug("videoUrl", videoUrl);
  console.debug("viewVideo", viewVideo);
  console.debug("videoFile", videoFile);
  console.debug("thumbnailFile", thumbnailFile);
  console.debug("downloadingVideo ", downloadingVideo);
  console.debug("error ", error);
  console.debug("timerStarted ", timerStarted);
  console.debug("test", props.currentVideoUrl);

  useEffect(() => {
    if (videoFile && thumbnailFile && tempFlag) {
      props.updateState({
        currentVideoUrl: videoUrl,
        uploadVideoFile: videoFile,
        videoThumbnail: thumbnailFile,
      });
      setTempFlag(false);
    }
  });

  const startRecordingHandler = () => {
    setTempFlag(false);
    if (videoFile) {
      setVideoFile("");
      setThumbnailFile("");
    }
    recordVideo.current.handleStartCaptureClick();
  };

  const stopRecordingHandler = () => {
    recordVideo.current.handleStopCaptureClick();
    setTempFlag(true);
  };

  return (
    <div className="container">
      {(videoFile && props.videoFileAvailable) || props.currentVideoUrl ? (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video src={props.currentVideoUrl} controls width={480} height={360}>
          {" "}
        </video>
      ) : (
        <RecordVideo
          onRecordingState={setRecording}
          onVideoUrlAvailable={setVideoUrl}
          onViewVideo={setViewVideo}
          onThumbnailFileAvailable={setThumbnailFile}
          onVideoFileAvailable={setVideoFile}
          onDownloadingVideo={setDownloadingVideo}
          onErrorOccurred={setError}
          onTimerStarted={setTimerStarted}
          fileName={`Video by ${props.fileName}`}
          recordingTime={120000}
          ref={recordVideo}
        />
      )}
      <div className="recordvideo-button-container">
        {(!videoFile || !props.videoFileAvailable) && !props.currentVideoUrl && (
          <div className="recordvideo-popup-info-list">
            <div
              className="attachvideo-record-stop"
              onClick={
                recording === "CanStart"
                  ? startRecordingHandler
                  : stopRecordingHandler
              }
              onKeyPress={() => {}}
              tabIndex="0"
              role="button">
              <div>
                {recording === "CanStart" && (
                  <Tooltip
                    placement="top"
                    overlay="Start recording"
                    align={{
                      offset: [6, 0],
                    }}>
                    <FontAwesomeIcon
                      className="recordvideo-popup-icon"
                      icon={["fas", "video-plus"]}
                      color="green"
                    />
                  </Tooltip>
                )}{" "}
                {recording === "CanStop" && (
                  <Tooltip
                    placement="top"
                    overlay="Stop recording"
                    align={{
                      offset: [6, 0],
                    }}>
                    <FontAwesomeIcon
                      className="stoprecord-popup-icon"
                      icon={["fas", "stop"]}
                      color="red"
                    />
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
        )}
        {tempFlag && <span>Please wait...</span>}
      </div>
    </div>
  );
};

export default RecordVideoComponent;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/RecordVideoPopup/RecordVideoComponent.js